import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import ConfirmationModal from '../../components/common/ConfirmationModal';
import { FaUserCircle, FaEdit, FaTrash } from 'react-icons/fa';
import PaginatedTable from '../../components/PaginatedTable';
import TitleWithBack from '../../components/common/TitleWithBack';

function UsersView() {
  const navigate = useNavigate();
  const [users, setUsers] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [filterRole, setFilterRole] = useState('');
  const [filterUserCategory, setFilterUserCategory] = useState('');
  const [sortColumn, setSortColumn] = useState('username');
  const [sortOrder, setSortOrder] = useState('asc');
  const [deleteId, setDeleteId] = useState(null);

  useEffect(() => { fetchUsers(); }, []);

  useEffect(() => {
    axios.get('/api/user-categories?page=0&size=10&sortBy=id')
      .then(response => {
        const cats = response.data.content || response.data;
        setCategories(cats);
      })
      .catch(err => console.error('Error fetching categories', err));
  }, []);

  const fetchUsers = () => {
    setLoading(true);
    axios.get('/api/users?page=0&size=20&sortBy=id')
      .then(response => {
        const usersData = response.data.content || response.data;
        console.log("User data:", usersData);
        const sorted = usersData.sort((a, b) => b.id - a.id);
        setUsers(sorted);
        setLoading(false);
      })
      .catch(err => {
        setError('Error fetching users.');
        setLoading(false);
      });
  };
  

  const getUserRole = (user) => user.roles && user.roles.length > 0 ? user.roles[0].name : '';
  const getUserCategory = (user) => user.userCategory && user.userCategory.name ? user.userCategory.name : '';

  const handleEdit = (userId) => { navigate(`/admin/users/edit/${userId}`); };

  const handleDelete = async (userId) => {
    try {
      await axios.delete(`/api/users/${userId}`);
      fetchUsers();
      setDeleteId(null);
    } catch (err) {
      setError('Error deleting user.');
    }
  };

  const handleSort = (column) => {
    if (sortColumn === column) {
      setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
    } else {
      setSortColumn(column);
      setSortOrder('asc');
    }
  };

  const filteredUsers = users.filter(user => {
    const role = getUserRole(user);
    const catId = user.userCategory && user.userCategory.id ? user.userCategory.id.toString() : '';
    return (filterRole ? role.toLowerCase() === filterRole.toLowerCase() : true) &&
           (filterUserCategory ? catId === filterUserCategory : true);
  });

  const sortedUsers = [...filteredUsers].sort((a, b) => {
    let aVal = '', bVal = '';
    if (sortColumn === 'role') {
      aVal = getUserRole(a).toLowerCase();
      bVal = getUserRole(b).toLowerCase();
    } else if (sortColumn === 'userCategory') {
      aVal = getUserCategory(a).toLowerCase();
      bVal = getUserCategory(b).toLowerCase();
    } else {
      aVal = (a[sortColumn] || '').toString().toLowerCase();
      bVal = (b[sortColumn] || '').toString().toLowerCase();
    }
    if (aVal < bVal) return sortOrder === 'asc' ? -1 : 1;
    if (aVal > bVal) return sortOrder === 'asc' ? 1 : -1;
    return 0;
  });

  const columns = [
    { key: 'serial', header: <>#</> },
    { key: 'username', header: <>Name</> },
    { key: 'email', header: <>Email</> },
    { key: 'role', header: <>Role</> },
    { key: 'userCategory', header: <>User Category</> },
    { key: 'contactNo', header: <>Contact No</> },
    {key: 'address', header: <>Address Of Institution</>},
    {key: 'enabled', header: <>status</>},
    { key: 'actions', header: 'Actions' }
  ];

  
    const renderRow = (user, idx, pageIndex, pageSize) => (
    <>
        <td>{(pageIndex * pageSize) + idx + 1}</td>
      <td>
        <FaUserCircle className="text-secondary me-2" />
        {user.username}
      </td>
      <td>{user.email}</td>
      <td>{getUserRole(user)}</td>
      <td>{getUserCategory(user)}</td>
      <td>{user.contactNo}</td>
      <td>{user.address}</td>
      <td className={user.enabled ? 'text-success' : 'text-danger'}>
         {user.enabled ? 'Unblocked' : 'Blocked'}
      </td>
      <td>
        <button className="btn btn-sm btn-primary me-2" onClick={() => handleEdit(user.id)}>
          <FaEdit /> Edit
        </button>
        <button className="btn btn-sm btn-danger" onClick={() => setDeleteId(user.id)}>
          <FaTrash /> Delete
        </button>
      </td>
    </>
  );

  return (
    <div className="container-fluid mt-2 px-4">
      <TitleWithBack title="View All Users" />
      <div className="mb-3">
        <label className="form-label me-2">Filter by Role:</label>
        <select className="form-select d-inline-block w-auto" value={filterRole} onChange={(e) => setFilterRole(e.target.value)}>
          <option value="">All</option>
          <option value="admin">Admin</option>
          <option value="archiver">Archiver</option>
          <option value="examiner">Examiner</option>
          <option value="data_team">Data Team</option>
          <option value="security">Security</option>
        </select>
        <label className="form-label ms-3 me-2">Filter by User Category:</label>
        <select className="form-select d-inline-block w-auto" value={filterUserCategory} onChange={(e) => setFilterUserCategory(e.target.value)}>
          <option value="">All</option>
          {categories.map(cat => (
            <option key={cat.id} value={cat.id}>{cat.name}</option>
          ))}
        </select>
      </div>
      {loading ? (
        <p>Loading users...</p>
      ) : error ? (
        <p className="text-danger">{error}</p>
      ) : sortedUsers.length === 0 ? (
        <p>Nothing to show here</p>
      ) : (
        <PaginatedTable data={sortedUsers} columns={columns} renderRow={renderRow} rowsPerPage={50} />
      )}
      {deleteId && (
        <ConfirmationModal 
          title="Confirm Delete"
          message="Are you sure you want to delete this user?"
          onConfirm={() => handleDelete(deleteId)}
          onCancel={() => setDeleteId(null)}
        />
      )}
    </div>
  );
}

export default UsersView;
